import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';

export default function Footer() {
  const { pathFor, t } = useLanguage();
  const f = t.footer;

  return (
    <footer className="bg-ct-ink text-gray-400 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-1">
            <Link to={pathFor('/')} className="flex items-center gap-2 mb-4" data-testid="footer-logo">
              <span
                aria-hidden="true"
                className="w-7 h-7 flex items-center justify-center bg-ct-brand text-white font-black text-sm"
                style={{ fontFamily: 'Chivo, sans-serif' }}
              >
                C
              </span>
              <span
                className="font-black text-xl text-white"
                style={{ fontFamily: 'Chivo, sans-serif' }}
              >
                CarniTrack
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-gray-500 max-w-xs">{f.tagline}</p>
            <div className="mt-5 inline-flex items-center gap-2 text-xs text-gray-500">
              <span className="ct-live-dot" />
              <span className="uppercase tracking-widest font-bold text-gray-400">
                {f.systemsOperational || 'All systems operational'}
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-[11px] font-bold uppercase tracking-widest text-gray-500 mb-4">
              {f.product}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href={pathFor('/#features')}
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                  data-testid="footer-link-features"
                >
                  {f.features}
                </a>
              </li>
              <li>
                <a
                  href={pathFor('/#pricing')}
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                  data-testid="footer-link-pricing"
                >
                  {f.pricing}
                </a>
              </li>
              <li>
                <Link
                  to={pathFor('/setup')}
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                  data-testid="footer-link-setup"
                >
                  {f.setup}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] font-bold uppercase tracking-widest text-gray-500 mb-4">
              {f.company}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <span className="text-sm text-gray-500 cursor-not-allowed" aria-disabled="true">
                  {f.about}
                </span>
              </li>
              <li>
                <span className="text-sm text-gray-500 cursor-not-allowed" aria-disabled="true">
                  {f.contact}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] font-bold uppercase tracking-widest text-gray-500 mb-4">
              {f.legal}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <span className="text-sm text-gray-500 cursor-not-allowed" aria-disabled="true">
                  {f.privacy}
                </span>
              </li>
              <li>
                <span className="text-sm text-gray-500 cursor-not-allowed" aria-disabled="true">
                  {f.terms}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <p className="text-xs text-gray-600">{f.copyright}</p>
          <p
            className="text-[11px] text-gray-600 font-mono tracking-wide"
            style={{ fontFamily: 'IBM Plex Mono, monospace' }}
          >
            v1 · built for industrial ops
          </p>
        </div>
      </div>
    </footer>
  );
}
